// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFound_wrapper"};